/* eslint-disable */
// @ts-nocheck

import { format } from 'date-fns'
import { es } from 'date-fns/locale'
import { FilterX, X } from 'lucide-react'
import { useState } from 'react'
import { DateRange } from 'react-day-picker'

import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'

interface Props {
  filter: Record<string, string>
  removeFilter: (key: string) => void
  removeAllFilters: () => void
}
export const SelectionSummary = ({
  filter,
  removeFilter,
  removeAllFilters,
}: Props) => {
  return (
    <div className="mt-2 flex flex-wrap gap-2">
      {Object.entries(filter || {}).map(([key, value], idx) => (
        <Badge
          className="gap-1 rounded-full py-1.5 pl-2 pr-1"
          key={key + idx.toString()}
          variant="secondary"
        >
          <span>
            {key}: {value}
          </span>
          <Button
            className="ml-1 h-4 w-4"
            onClick={() => removeFilter(key)}
            size="icon"
            variant="ghost"
          >
            <X className="h-3 w-3" />
          </Button>
        </Badge>
      ))}
      <Button
        className="h-7 gap-1 text-xs"
        onClick={removeAllFilters}
        size="sm"
        variant="ghost"
      >
        <FilterX className="h-3.5 w-3.5" />
        Limpiar filtros
      </Button>
    </div>
  )
}
